import {WelcomeDialogModel} from './welcome-dialog.model';
import {NotificationType} from '@pes/ui';


export class WelcomeDialogModelBuilder {
    public static build(title: string = 'gui.dialog.confirm.confirm', message: string = 'gui.dialog.confirm.r_u_sure',
                        type: NotificationType = NotificationType.WARNING,
                        submitBtnText: string = 'gui.dialog.confirm.submit_btn_text'): WelcomeDialogModel {
        const model: WelcomeDialogModel = {
            title: title,
            message: message,
            type: type,
            submitBtnText: submitBtnText
        };
        return model;
    }
}



// WEBPACK FOOTER //
// ./src/app/component/dialog/welcome-dialog/welcome-dialog-model.builder.ts